<template>
  <div>
    <h1>Digital iko Tema</h1>
    <p>{{ data.meta.description }}</p>
    <p class="check">{{ $t('check projects') }}:</p>
    <ul>
      <li>
        <router-link :to="{ name: 'andres', params: {lang: $route.params.lang}}">
          Andrés
        </router-link>
      </li>
      <li>
        Laércio
      </li>
    </ul>
  </div>
</template>

<script>
import data from '@/dataLoader'
import {metaSetter} from '@/mixins'

export default {
  mixins: [metaSetter],
  computed: {
    data () { return data.digital[this.$i18n.locale] }
  }
}
</script>

<style scoped lang="scss">
p {
  max-width: 35rem;
  margin: 0 auto;
}
p.check {
  margin-top: 2rem;
}
ul {
  margin: 0;
}
h1 {
  margin-top: 6rem;
  font-family: NunitoSansExtraLight, Helvetica, Arial, sans-serif;
  font-size: 50pt;
}
.name-meaning {
  display: inline-block;
  padding: 1rem;
  background-color: #f3f3f3;
  p {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue